import {
  getKvlistGql,
  addKvGql,
  deleteKvGql,
  updateKvGql,
  updateKvByKeyGql,
} from '@/graphql/gql/kv';
import { calVariables, request } from '@/graphql/util';

export async function getKvlist(data) {
  const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(getKvlistGql, data),
  });
  return result;
}
const kvGql = (gql, data) => {
  let fieldList = '';
  const keyList = {
    key: 'key',
    value: 'value',
    remark: 'remark',
    type: 'type',
    valType: 'value_type',
    valExt: 'value_ext',
    isLocked: 'is_locked',
    isEnvSpecific: 'is_env_specific',
  };
  Object.keys(data).forEach((key) => {
    if (keyList[key]) {
      fieldList += `${keyList[key]}:$${key},`;
    }
  });
  return gql.replace('fieldList', fieldList);
};
export async function addKv(data) {
  const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(kvGql(addKvGql, data), data),
  });
  return result;
}
export async function deleteKv(data) {
  const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(deleteKvGql, data),
  });
  return result;
}
export async function updateKv(data) {
  const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: calVariables(kvGql(updateKvGql, data), data),
  });
  return result;
}
export async function updateKvByKey(data) {
  const updateList = [];
  data.forEach((item) => {
    updateList.push(calVariables(kvGql('{fieldList}', item), item));
  });
  // const gql = updateKvByKeyGql.replace('$tableName', 'kv').replace('$updateList', updateList.join(','));
  let updateListStr = calVariables('$updateList', {
    updateList: updateList.join(','),
    tableName: 'kv',
  });
  updateListStr = updateListStr.substring(1, updateListStr.length - 1);
  const gql = updateKvByKeyGql.replace('$tableName', 'kv').replace('$updateList', updateListStr);
  const result = await request('/api/access/pb/cmd/DataServer/DataService/GraphqlQuery', {
    query: gql,
  });
  return result;
}
